import { ExportTypeCodes } from "./export-type-codes.enum";

export const exportTypeList = [
    {label: "XML", value: ExportTypeCodes.XML, icon: "xml-file"},
    {label: "CSV", value: ExportTypeCodes.CSV, icon: "csv-file"},
    {label: "XLSX", value: ExportTypeCodes.EXCEL, icon: "xlsx-file"},
    {label: "ZIP", value: ExportTypeCodes.ZIP, icon: "zip-file"},
]